// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5[data-v-1f9c5925],h6[data-v-1f9c5925]{font-weight:700;text-align:center}.content[data-v-1f9c5925],.title[data-v-1f9c5925]{display:flex;align-items:center;justify-content:center}.required[data-v-1f9c5925]:after{content:\" *\";color:red}", ""]);
// Exports
module.exports = exports;
